import { dispatchHandler } from "../helpers/dispatchHandler";
import axios from "axios";
import {
    ERROR, GET_SELECTED_MENU, GET_TECHNOLOGIES,
    USER_INFO,
} from "./type";
const header = {
    headers: { "access-token": localStorage.getItem("token") },
};

export const systemLogin =
    (request) =>
        async (dispatch) => {
            try {
                const URL = `/api/user/ldap-sign-in`;
                const { data } = await axios.post(URL, request);
                if (data) {
                    localStorage.setItem("token", data.accessToken);
                    localStorage.setItem("user", JSON.stringify(data.data));

                    dispatchHandler({
                        type: USER_INFO,
                        data: data.data,
                        dispatch,
                    });
                    window.location.href = "/admin/dashboard";
                }
                return data;
            } catch (error) {
                dispatchHandler({
                    type: ERROR,
                    data: error?.data?.message,
                    dispatch,
                });
                return null;
            }
        };

export const inArray = (haystack, needle) => {
    if (!haystack) {
        return false;
    }
    return haystack.filter(v => v === needle).length > 0;
}
export const submitGeneralForm =
    async (URL,body,onUploadProgress) => {
            try {
                const {data} = await axios.post(URL, body, {...header,onUploadProgress});
                return {data,status:true};
            } catch (error) {
                return { data: error, status: false };
            }
        };


export const getLoggedUser =
    () =>
    async (dispatch) => {
        try {

                const data = JSON.parse(localStorage.getItem("user"));
                dispatchHandler({
                    type: USER_INFO,
                    data: data,
                    dispatch,
                });

        } catch (error) {

        }
    };
export const setSelectedMenu =
    (data) =>
    async (dispatch) => {
        try {
                dispatchHandler({
                    type: GET_SELECTED_MENU,
                    data: data,
                    dispatch,
                });

        } catch (error) {

        }
    };

export const downloadBase64 =
    (id,name,type ,fileType ,specialName) =>
    async () => {
        try {
            const axios_URL = `/api/download/file/${id}?type=${type}&key=${name}&specialName=${specialName}`;
            const { data } = await axios.get(
                axios_URL,
                {
                    ...header,
                    responseType: "blob",
                }
            );
            if (data) {
                const file = new Blob([data], {
                    type:fileType,
                });
                return await blobToBase64(file);
            }
        } catch (error) {
            return null;
        }
    };


export const generalDownload =
    (id,type,name,specialName) =>
    async () => {
        try {
            const axios_URL = `/api/download/file/${id}?type=${type}&key=${name}&specialName=${specialName}`;
            const { data,headers } = await axios.get(
                axios_URL,
                {
                    ...header,
                    responseType: "blob",
                }
            );
            if (data) {
                const file = new Blob([data], {
                    type,
                });
                let filename = headers['content-disposition'].split('filename=').pop();
                // saveAs(file,filename ?? name);
            }
        } catch (error) {
        }
    };

function blobToBase64(blob) {
    return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
}
export const deleteAction =
    (URL) =>
        async () => {
            try {
                const { data } = await axios.delete(URL, header);
                return { data, status: true };
            } catch (error) {
                return { data: error, status: false };
            }
        };

         export const  fetchDetails =
         async (URL) => {
            try {
                const { data } = await axios.get(URL, header);
                return { data, status: true };
            } catch (error) {
                return { data: error, status: false };
            }
        };
        
export const putAction =
    (URL,map) =>
        async () => {
            try {
                const {data} = await axios.put(URL,map, header);
                return {data,status:true};
            } catch (error) {
                return {data:error,status:false};
            }
        };

export const getTechnologies =
    (uri) =>
        async (dispatch) => {
            try {
                const URL = uri ?? 'api/technology/get/approved';
                const { data } = await axios.get(URL, header);
                dispatchHandler({
                    type: GET_TECHNOLOGIES,
                    data: data.list,
                    dispatch,
                });
                return { data, status: true };
            } catch (error) {
                return { data: error, status: false };
            }
        };


